'use strict';

module.exports = function combine(array) {
  var collection = {};

  this.items.forEach(function (key, iterator) {
    collection[key] = array[iterator];
  });

  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/combine.js
// module id = 1215
// module chunks = 2